import React, { Component } from "react"
import Link from '../utils/link'
import { graphql } from 'gatsby'
import SEO from "../components/seo"

class ServicesPage extends Component {

  render() {
    
    const { page } = this.props.data

    return (
      <>
        <SEO title='Services' bodyClass='services' />
        <section className='page'>
          <div className='page__inner'>
            <div className='page__columns'>
            	<div className='page__col'>
            		<img src={page.Services.services.image.sourceUrl} alt='Emily Gillis' />
            	</div>
            	<div className='page__col'>
            		<h1 className='page__title page__title'>{page.Services.services.title}</h1>
    						<div dangerouslySetInnerHTML={{ __html: page.Services.services.content }} />
                <div className='steps'>
                  { page.Services.steps.map((el, i) => {
                    return (
                      <div className='steps__item'>
                        <h4>{el.title}</h4>
                        <div dangerouslySetInnerHTML={{ __html: el.content }} />
                      </div>
                    )
                  })}
                  <Link className='btn' to='mailto:studio@emilygillis.com.au'>Book in a 10 minute discovery call</Link> 
                </div>  
            	</div>
            </div>
          </div>
        </section>
      </>
    )

  }

}

export default ServicesPage

export const servicesQuery = graphql`
  query {
    page: wpPage(slug: { eq: "services" }){
      title
      seo {
        title
        metaDesc
      }
      Services {
        services {
          title
          content
          image {
            sourceUrl
          }
        }
        steps {
          title
          content
        }
      }
    }
  }
`
